import { createSelector } from 'reselect'
import API from '../../../utils/http/api'

// Action Types
const REQUEST = 'steppingblocks/studentInvitations/REQUEST'
const FAILURE = 'steppingblocks/studentInvitations/FAILURE'
const RETRIEVE_SUCCESS = 'steppingblocks/studentInvitations/RETRIEVE_SUCCESS'
const INVITE_SUCCESS = 'steppingblocks/studentInvitations/INVITE_SUCCESS'
const RESEND_SUCCESS = 'steppingblocks/studentInvitations/RESEND_SUCCESS'
const SET_SEARCH_FILTER = 'steppingblocks/studentInvitations/SET_SEARCH_FILTER'

const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  results: [],
  searchFilter: '',
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case REQUEST:
      return {
        ..._state,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case RETRIEVE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results
      }
    case INVITE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: _state.results.concat(payload.result),
      }
    case RESEND_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case SET_SEARCH_FILTER:
      return {
        ..._state,
        searchFilter: payload.data,
      }
    default:
      return _state
  }
}

// Actions

/**
 * @const setSearchFilter
 * @description Sets the search filter
 * @param {String} data
 */
export const setSearchFilter = data => ({ type: SET_SEARCH_FILTER, payload: { data } })

/**
 * @const performRetrieveStudentInvites
 * @description Retrieves invitations
 */
export const performRetrieveStudentInvites = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/invitations/student_invitations')
    dispatch({
      type: RETRIEVE_SUCCESS,
      payload: {
        results,
      }
    })
    return results
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
  }
}

/**
 * @const performInviteStudent
 * @description Invites a Student
 * @param params
 */
export const performInviteStudent = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post('/invitations/student_invitations', params)
    dispatch({
      type: INVITE_SUCCESS,
      payload: {
        result: data.invitation,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    throw new Error(error.message)
  }
}

/**
 * @const performResendInvite
 * @description Resends an invitation to a student
 * @param invitationId
 */
export const performResendInvite = invitationId => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.get(`/invitations/student_invitations/${invitationId}/resend`)
    dispatch({
      type: RESEND_SUCCESS,
    })
    return true
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    throw new Error(error.message)
  }
}

// Selectors
const getStudentInvitations = state => state.studentInvitations
const getInvitations = createSelector(getStudentInvitations, _ => _.results)
const getSearchFilter = createSelector(getStudentInvitations, _ => _.searchFilter)

export const getError = createSelector(getStudentInvitations, _ => _.error)

export const getFilteredInvitations = createSelector(
  [getInvitations, getSearchFilter],
  (invitations, filter) =>
    invitations.filter(invite => invite.inviteeEmail.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/studentInvitiationsDuck.js